import React, { useState } from 'react'
import { BasicText } from 'informed'
import wrapField from '../shared/wrapField'
import styled from 'styled-components'

import { ReactComponent as HidePwd } from './hide_pwd.svg'
import { ReactComponent as ShowPwd } from './show_pwd.svg'

const ButtonContainer = styled.div`
	position: absolute;
	height: 100%;
  width: 36px;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
  	cursor: pointer;
  }
`

const TextField = ({ smartSubmit, fieldState, fieldApi, innerRef, noForm, onChange, onBlur, resolvePlaceholder, type: propsType, pwdVisibilityBtn, ...props }) => {
	const [type, setType] = useState(propsType)
	const fieldComponent = fieldState && fieldApi ? (
		<BasicText
			ref={innerRef}
			fieldApi={fieldApi}
			fieldState={fieldState}
			type={type}
			onBlur={(e) => {
				if(onBlur) {
					onBlur(e)
				}
				if(smartSubmit) {
					smartSubmit.submit(e)
				}
			}}
			onChange={(e) => {
				if(onChange) {
					onChange(e)
				}
				if(smartSubmit) {
					smartSubmit.delay(e)
				}
			}}
			placeholder={resolvePlaceholder('text')}
			{...props}
		/>
	) : (
		<input
			placeholder={resolvePlaceholder('text')}
			{...props}
			onChange={onChange}
			type={type}
			onBlur={onBlur}
			ref={innerRef}
		/>
	)

	const PwdVisibilityButton = type === 'password' ? ShowPwd : HidePwd

	const handlePwdVisibility = () => {
		setType(prevType => {
			return prevType === 'password' ? 'text' : 'password'
		})
	}

	return (
		<>
			{fieldComponent}
			{propsType === 'password' && pwdVisibilityBtn && !props.hidden &&
				<ButtonContainer>
					<PwdVisibilityButton onClick={handlePwdVisibility}/>
				</ButtonContainer>
			}
		</>
	)
}


export default wrapField(TextField)
